/* This ensures that the drop-down menu items cannot be wider than the max-width of the scope column */
.issueTypeLabel {
	max-width: 215px;
	display: inline-block;
}
